import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Adres satırındaki #capa bolumune kaydirir.
//
// Iki zorluk var:
//
// 1) Anasayfa bolumleri Strapi'den asenkron geldigi icin, disaridan
//    "/#uzmanliklarimiz" veya "/en#..." ile gelindiginde hedef bolum ilk
//    anda DOM'da olmayabilir.
// 2) Bolum geldikten sonra da gorseller yuklendikce konumu asagi kayar.
//
// Bu yuzden: bolum hazirsa once sitenin alisildik yumusak kaydirmasi
// uygulanir, ardindan yerlesim oturana kadar konum hizada tutulur.
// Yumusak kaydirma calismazsa (ornegin arka plandaki sekmede tarayici
// animasyonu durdurur) hizalama dogrudan devreye girer.
// Kullanici kendi kaydirirsa mudahale birakilir.

const HEADER_OFFSET = 119;
const POLL_MS = 150;
const ALIGNED_TICKS = 10; // ~1.5 sn hizada kalirsa yerlesim oturmus sayilir
const SMOOTH_GRACE_TICKS = 10; // yumusak kaydirmaya taninan ~1.5 sn
const MAX_TICKS = 110; // en fazla ~16 saniye

function ScrollToAnchor() {
  const location = useLocation();
  const lastHash = useRef("");

  useEffect(() => {
    if (location.hash) {
      lastHash.current = location.hash.slice(1);
    }

    const id = lastHash.current;
    if (!id) return;

    let timerId = 0;
    let ticks = 0;
    let alignedTicks = 0;
    let graceTicks = 0;
    let cancelled = false;

    const cancel = () => {
      cancelled = true;
    };

    // Bolum hazirsa: yumusak kaydirma.
    const readyElement = document.getElementById(id);
    if (readyElement) {
      readyElement.style.scrollMarginTop = `${HEADER_OFFSET}px`;
      readyElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
      graceTicks = SMOOTH_GRACE_TICKS;
    }

    window.addEventListener("wheel", cancel, { passive: true });
    window.addEventListener("touchstart", cancel, { passive: true });
    window.addEventListener("keydown", cancel);

    const tick = () => {
      if (cancelled) return;
      ticks += 1;

      const element = document.getElementById(id);
      if (element) {
        element.style.scrollMarginTop = `${HEADER_OFFSET}px`;

        const target = Math.max(
          0,
          Math.round(
            element.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET
          )
        );

        if (Math.abs(window.scrollY - target) <= 4) {
          alignedTicks += 1;
          if (alignedTicks >= ALIGNED_TICKS) {
            lastHash.current = "";
            return;
          }
        } else {
          alignedTicks = 0;
          if (graceTicks > 0) {
            graceTicks -= 1; // yumusak kaydirma suruyor olabilir, biraz bekle
          } else {
            window.scrollTo(0, target);
          }
        }
      }

      if (ticks < MAX_TICKS) {
        timerId = window.setTimeout(tick, POLL_MS);
      }
    };

    timerId = window.setTimeout(tick, POLL_MS);

    return () => {
      cancelled = true;
      window.clearTimeout(timerId);
      window.removeEventListener("wheel", cancel);
      window.removeEventListener("touchstart", cancel);
      window.removeEventListener("keydown", cancel);
    };
  }, [location]);

  return null;
}

export default ScrollToAnchor;
